import { UserEligibilityKeys } from 'constants/user-eligibility';
import { MultiChoiceType } from 'components/multichoice-button';

export const isUserStatusNeedsReview = (pageValue: MultiChoiceType[], userStatus: string) =>
    pageValue?.length > 0 &&
    pageValue[0].value !== 'none' &&
    userStatus === UserEligibilityKeys.userStatus.approved;
